import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import IconViewerContainer from '../Components/IconViewerContainer';
//import DeleteFieldOfStudyModal from "../DeleteIconModal";
import { useBoolean } from '@fluentui/react-hooks';
//import ErrorComponent from '../../../../Util/ErrorComponent';
//import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedFieldsOfStudy, setSelectedFieldsOfStudy] = useState(undefined);
      const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: iconsAll, loading }, refetch] = useAxios("resources/icon-viewer/all");
    const [{ data: categories, categoriesLoading }] = useAxios("resources/icon-viewer/categories");

    if (loading || categoriesLoading) return <Spinner className="absolute-center" label="Loading icons..." />;

    return (
        <IconViewerContainer
            iconsAll={iconsAll}
            categories={categories}
        />
    );
};

export default DefaultPage;
